import { useState, ChangeEvent, FormEvent } from "react";
import {
	Button,
	Box,
	CircularProgress,
	Checkbox,
	FormControlLabel,
	IconButton,
} from "@mui/material";
import CustomField from "./CustomField";
import { IProps } from "../../types/CommonTypes";
import {
	getCurrentDate,
	getImageById,
} from "../../commons/constants/helpers";
import useServices from "../../commons/hooks/useServices";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { toast } from "react-toastify";
import "../landing/landing.css";

interface FormValues {
	name: string;
	phoneNumber: string;
	report: string;
	date: string;
}

const initialState = {
	name: "",
	phoneNumber: "",
	report: "",
	date: "",
};

const Form = ({ item }: IProps) => {
	const [formValues, setFormValues] = useState<FormValues>(initialState);
	const { handelSubmitReport, loading } = useServices();
	const [checked, setChecked] = useState<boolean>(false);
	const [file, setFile] = useState<any>(null);

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		if (name === "phoneNumber") {
			setFormValues((prevValues) => ({
				...prevValues,
				[name]: value.replace(/[^0-9]/g, ""),
			}));
		} else {
			setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
		}
	};

	const handleSubmit = async (event: FormEvent) => {
		event.preventDefault();
		if (!checked) return;
		await handelSubmitReport({
			...formValues,
			date: getCurrentDate(),
			file: file,
		});
		setFile(null);
		setChecked(false);
		setFormValues(initialState);
	};

	const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
		if (e.target.files && e.target.files[0]) {
			const selectedFile = e.target.files[0];

			if (selectedFile.size > 100 * 1024 * 1024) {
				toast.error(
					"El archivo seleccionado es demasiado grande. Por favor, elige un archivo que pese menos de 100MB"
				);
				return;
			}

			setFile(selectedFile);
		}
	};

	return (
		<section id="denuncias" className="ld-report">
			<h2 className="ld-sr-only">Denuncia aquí</h2>
			<div className="ld-container ld-report-grid">
				<div className="ld-report-art">
					<img
						src={getImageById("title", item)}
						alt="Denuncia aquí"
						className="ld-report-title-img"
					/>
					<img
						src={getImageById("megaphone", item)}
						alt=""
						aria-hidden="true"
						className="ld-report-megaphone"
					/>
				</div>

				<div className="ld-report-card">
					<p className="ld-report-lead">
						Cuéntanos tu denuncia con el mayor detalle posible.
						Puedes adjuntar pruebas en un archivo .zip.
					</p>
					<form onSubmit={handleSubmit}>
						<CustomField
							fullWidth
							label="Nombre"
							name="name"
							value={formValues.name}
							onChange={handleChange}
							inputProps={{ maxLength: 100 }}
							placeholder="Nombre"
						/>
						<CustomField
							fullWidth
							label="Número de celular"
							name="phoneNumber"
							value={formValues.phoneNumber}
							onChange={handleChange}
							inputProps={{ maxLength: 11 }}
							placeholder="Número de celular"
						/>
						<CustomField
							fullWidth
							label="Denuncia"
							name="report"
							value={formValues.report}
							onChange={handleChange}
							multiline
							rows={8}
							inputProps={{ maxLength: 3000 }}
							placeholder="Denuncia"
						/>
						<input
							accept=".zip"
							id="contained-button-file"
							type="file"
							style={{ display: "none" }}
							onChange={handleFileChange}
						/>
						{!file ? (
							<label htmlFor="contained-button-file">
								<Button
									fullWidth
									variant="outlined"
									component="span"
									sx={{ my: 1 }}
									disabled={loading}
								>
									Cargar Archivo (.zip)
								</Button>
							</label>
						) : (
							<Box
								sx={{
									my: 1,
									display: "flex",
									alignItems: "center",
								}}
							>
								<p>{file.name}</p>
								<IconButton onClick={() => setFile(null)}>
									<RemoveCircleIcon color="error" />
								</IconButton>
							</Box>
						)}
						<FormControlLabel
							control={
								<Checkbox
									checked={checked}
									onChange={(e) => setChecked(e.target.checked)}
									color="primary"
								/>
							}
							label="Acepto el uso y tratamiento de datos personales"
						/>
						{!loading ? (
							<Button
								type="submit"
								variant="contained"
								color="primary"
								fullWidth
								style={{
									borderRadius: "20px",
									display: checked ? "flex" : "none",
								}}
							>
								Enviar
							</Button>
						) : (
							<Box
								style={{
									display: "flex",
									justifyContent: "center",
								}}
							>
								<CircularProgress />
							</Box>
						)}
					</form>
				</div>
			</div>
		</section>
	);
};

export default Form;
